import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=412a9e6c&scoped=true"
import script from "./ShopDetail.vue?vue&type=script&lang=ts"
export * from "./ShopDetail.vue?vue&type=script&lang=ts"
import style0 from "./ShopDetail.vue?vue&type=style&index=0&id=412a9e6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a9e6c",
  null
  
)

export default component.exports